<template>
    <section>
        <div class="cabinet-content-wrap">
            <HeaderPublic />

            <MainBanners />

            <section class="cabinet__welcome-section">
                <div class="cabinet__product-list_wrap">
                    <p v-if="loadingCategories.categories">Loading...</p>
                    <ul v-else class="cabinet__product-list cabinet__product-list--scroll">
                        <li v-for="categorie in categories.slice(0, 6)" :key="categorie.id" class="cabinet__product-list__product-item cabinet__product-list__product-item--new">
                            <router-link :to="`/catalog/category/${categorie.url}`">
                                <div class="cabinet__product-list__product-item__img">
                                    <img v-if="categorie.image_url" :src="categorie.image_url" :alt="categorie.name" />
                                    <img v-else src="img/no-photo.jpg" :alt="categorie.name" />
                                </div>
                                <h4 class="cabinet__product-list__product-item__title-h4">
                                    {{ categorie.name }}
                                </h4>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </section>

            <section class="brand-section">
                <div class="brand-page">
                    <div class="brand-page__title">Новинки</div>

                    <div class="cabinet__catalog">
                        <p v-if="loadingItems.items || !products">Loading...</p>

                        <div v-else-if="items && !isRetailer" class="brand-page__swiper">
                            <div class="swiper__button swiper__button-prev js-products-prev-1"></div>
                            <div class="swiper__button swiper__button-next js-products-next-1"></div>
                            <div class="swiper swiper-products-1">
                                <div class="swiper-wrapper">
                                    <div v-for="item in items.slice(0, 8)" :key="item.ItemID" class="swiper-slide">
                                        <div class="cabinet__catalog-item d-flex flex-column">
                                            <router-link :to="`/catalog/product/${item.ItemID}`" class="cabinet__catalog-image">
                                                <img v-if="item.images" :src="item.images[0].url" :alt="item.brand.BrandName" />
                                                <img v-else src="img/no-photo.jpg" :alt="item.brand.BrandName" />
                                            </router-link>

                                            <div class="cabinet__catalog-title d-flex align-items-center mb-auto">
                                                <a v-if="item.brand.subdomain_url" :href="item.brand.subdomain_url" class="cabinet__catalog-title_value">
                                                    {{ item.brand.BrandName }}
                                                </a>
                                                <router-link v-else :to="`/brands/${item.brand.BrandID}`" class="cabinet__catalog-title_value">
                                                    {{ item.brand.BrandName }}
                                                </router-link>
                                            </div>

                                            <div class="cabinet__catalog-category">
                                                {{ item.Category_src }}
                                            </div>

                                            <div class="cabinet__catalog-code">
                                                {{ item.Article }}
                                            </div>

                                            <div class="cabinet__catalog-tags d-flex flex-wrap subtitle2">
                                                <div v-for="material in item.materials" :key="material.MaterialID" class="cabinet__catalog-tag">
                                                    <a href="javascript:void(0)">{{ material.Name }}</a>
                                                </div>
                                            </div>

                                            <div class="cabinet__catalog-info">
                                                <div v-if="item.price_expired == false && item.Price > 0" class="cabinet__catalog-price">{{ item.Price }} Р/шт</div>
                                                <div v-if="item.Weight" class="cabinet__catalog-weight">{{ item.Weight }} гр</div>
                                            </div>

                                            <adding-and-deleting-to-public-cart :item="item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else class="cabinet__catalog-container d-flex flex-wrap justify-content-between">
                            <retailer-product-item v-for="product in products.slice(0, 8)" :key="product.ItemID" :product="product" />
                        </div>
                    </div>
                </div>
            </section>

            <div class="brand-section" v-for="brand in brandsBlocks" :key="brand.brand_page_id">
                <div class="about">
                    <div class="about__image">
                        <a :href="brand.brand.SubdomainUrl" target="_blank"><img :src="brand.banner_desktop" alt="" /></a>
                    </div>
                    <div class="brand-section">
                        <div class="brand-page">
                            <div class="brand-page__title">Украшения {{ brand.name }}</div>
                            <div class="brand-page__swiper">
                                <div class="swiper__button swiper__button-prev js-products-prev-2"></div>
                                <div class="swiper__button swiper__button-next js-products-next-2"></div>
                                <div class="swiper swiper-products-2">
                                    <div class="swiper-wrapper">
                                        <div v-for="item in brand.bestsellers" :key="item.ItemID" class="swiper-slide">
                                            <div class="cabinet__catalog-item">
                                                <div class="cabinet__catalog-favorite">
                                                    <div class="cabinet-favorite-checkbox">
                                                        <input type="checkbox" name="favorite" value="1" />
                                                        <span class="cabinet-favorite-checkbox__checkmark"></span>
                                                    </div>
                                                </div>
                                                <router-link :to="`/catalog/product/${item.ItemID}`" class="cabinet__catalog-image">
                                                    <img v-if="item.images" :src="item.images[0].url" />
                                                    <img v-else src="img/no-photo.jpg" />
                                                </router-link>
                                                <div class="cabinet__catalog-top">
                                                    <div class="cabinet__catalog-title d-flex align-items-center">
                                                        <div class="cabinet__catalog-title_value">
                                                            {{ brand.name }}
                                                        </div>
                                                    </div>
                                                    <div class="cabinet__catalog-category">
                                                        {{ item.Category_src }}
                                                    </div>
                                                </div>

                                                <div class="cabinet__catalog-tags d-flex flex-wrap subtitle2">
                                                    <div v-for="material in item.materials" :key="material.MaterialID" class="cabinet__catalog-tag">
                                                        <a href="javascript:void(0)">{{ material.Name }}</a>
                                                    </div>
                                                </div>
                                                <div class="cabinet__catalog-info">
                                                    <div class="cabinet__catalog-price" v-if="item.Price > 0 && item.price_expired == false">{{ item.Price }} Р/шт</div>
                                                    <div v-if="item.Weight" class="cabinet__catalog-weight">{{ item.Weight }} гр</div>
                                                </div>

                                                <adding-and-deleting-to-public-cart :item="item" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section class="brand-section">
                <div class="brand-page">
                    <h3 class="brand-page__title">Бренды</h3>
                    <p v-if="!brands">Loading...</p>
                    <div v-else class="brands">
                        <div v-for="brand in brands.slice(0, 8)" :key="brand.BrandID" class="brands__item">
                            <a v-if="brand.subdomain_url" :href="brand.subdomain_url" class="app-link">
                                <div class="brands__item-image">
                                    <img v-if="brand.logo" :src="brand.logo" :alt="brand.BrandName" class="dashboard-brand__img ofi" />
                                    <img v-else src="img/no-photo.jpg" :alt="brand.BrandName" class="dashboard-brand__img ofi" />
                                </div>
                                <div class="brands__item-name">
                                    {{ brand.BrandName }}
                                </div>
                            </a>
                            <router-link v-else :to="isRetailer ? `/account/brands/${brand.BrandID}` : `/brands/${brand.BrandID}`" class="app-link">
                                <div class="brands__item-image">
                                    <img v-if="brand.logo" :src="brand.logo" :alt="brand.BrandName" class="dashboard-brand__img ofi" />
                                    <img v-else src="img/no-photo.jpg" :alt="brand.BrandName" class="dashboard-brand__img ofi" />
                                </div>
                                <div class="brands__item-name">
                                    {{ brand.BrandName }}
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="brand-page__button">
                        <router-link v-if="!isRetailer" to="/brands" class="button">Смотреть все бренды</router-link>
                        <router-link v-else to="/account/brands" class="button">Смотреть все бренды</router-link>
                    </div>
                </div>
            </section>
            <section class="cabinet__what-is-goldnet cabinet__what-is-goldnet--new">
                <h2 class="cabinet__what-is-goldnet__title-h2">
                    Что такое goldnet.market?
                </h2>

                <ul class="cabinet__what-is-goldnet__list-of-services">
                    <li class="cabinet__what-is-goldnet__list-of-services__item">
                        <h3 class="cabinet__what-is-goldnet__list-of-services__item__title-h3">
                            Широкий ассортимент
                        </h3>
                        <p class="cabinet__what-is-goldnet__list-of-services__item__service-description">
                            На платформе размещен ассортимент ведущих производителей и поставщиков ювелирных изделий всех секторов рынка — от массового серебряного до эксклюзивного и авторского.
                        </p>
                    </li>

                    <li class="cabinet__what-is-goldnet__list-of-services__item cabinet__what-is-goldnet__list-of-services__item--2">
                        <h3 class="cabinet__what-is-goldnet__list-of-services__item__title-h3">
                            Покупка напрямую у производителей
                        </h3>
                        <p class="cabinet__what-is-goldnet__list-of-services__item__service-description">
                            Вы отправляете заказ напрямую производителю, что гарантирует подлинность изделий и отсутствие лишних наценок.
                        </p>
                    </li>

                    <li class="cabinet__what-is-goldnet__list-of-services__item">
                        <h3 class="cabinet__what-is-goldnet__list-of-services__item__title-h3">
                            Оптовые продажи
                        </h3>
                        <p class="cabinet__what-is-goldnet__list-of-services__item__service-description">
                            Зарегистрируйте свое юридическое лицо или ИП, и получите доступ к расширенному функционалу для более эффективных оптовых закупок.
                        </p>
                    </li>
                </ul>
            </section>
        </div>

        <section class="cabinet__invitation-to-cooperation cabinet__invitation-to-cooperation--new">
            <div class="cabinet-content-wrap">
                <h2 class="cabinet__invitation-to-cooperation__title-h2">
                    Приглашаем к сотрудничеству
                </h2>

                <p class="cabinet__invitation-to-cooperation__text">
                    Приглашаем присоединиться к нашей платформе оптовых покупателей и поставщиков.
                </p>

                <a href="/partners" class="cabinet-btn cabinet-btn--default-link d-inline-block">
                    Узнать больше
                </a>
            </div>
        </section>
    </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'

import HeaderPublic from '@/components/Public/PublicHeader'
import MainBanners from '@/components/Public/Main/Banners'
import AddingAndDeletingToPublicCart from '@/components/Public/AddingAndDeletingToPublicCart'
import RetailerProductItem from '@/components/Cabinet/Retailer/ProductItem'

export default {
    name: 'Home',

    data() {
        return {
            swiperSlider: null
        }
    },

    components: {
        HeaderPublic,
        MainBanners,
        AddingAndDeletingToPublicCart,
        RetailerProductItem
    },

    computed: {
        ...mapState('retailerProducts', ['products']),
        ...mapGetters({
            items: 'publicItems',
            loadingItems: 'publicItemsLoading',
            isRetailer: 'isRetailer'
        }),
        ...mapGetters('publicCategories', {
            categories: 'categories',
            loadingCategories: 'loading'
        }),
        ...mapGetters('user', ['isRetailer']),
        ...mapState('publicBrands', ['brands']),
        ...mapState('mainbrands', {
            brandsBlocks: 'brands'
        })
    },

    created() {
        if (this.isRetailer) {
            this.getProducts({ page: 1, sort_by: 'New' })
            this.getLists()
            this.getBrands({ sort_by: 'New' })
        } else {
            this.getPublicItems().then(() => {
                this.$nextTick(() => {
                    this.swiperSlider = new Swiper('.swiper-products-1', {
                        slidesPerView: 4,
                        spaceBetween: 32,
                        direction: 'horizontal',
                        navigation: {
                            nextEl: '.js-products-next-1',
                            prevEl: '.js-products-prev-1',
                            disabledClass: 'hide'
                        },
                        breakpoints: {
                            1023: {
                                slidesPerView: 3,
                                spaceBetween: 24
                            },
                            767: {
                                slidesPerView: 3.59,
                                spaceBetween: 16
                            },
                            575: {
                                slidesPerView: 1.48,
                                spaceBetween: 16
                            }
                        }
                    })
                })
            })
            this.getBrands({ sort_by: 'New' })
            this.setCartPublicFromLocStor()
        }
        this.getMainBrands().then(() => {
            this.$nextTick(() => {
                this.swiperSlider = new Swiper('.swiper-products-2', {
                    slidesPerView: 4,
                    spaceBetween: 32,
                    direction: 'horizontal',
                    navigation: {
                        nextEl: '.js-products-next-2',
                        prevEl: '.js-products-prev-2',
                        disabledClass: 'hide'
                    },
                    breakpoints: {
                        1023: {
                            slidesPerView: 3,
                            spaceBetween: 24
                        },
                        767: {
                            slidesPerView: 3.59,
                            spaceBetween: 16
                        },
                        575: {
                            slidesPerView: 1.48,
                            spaceBetween: 16
                        }
                    }
                })
            })
        })
    },

    methods: {
        ...mapActions(['getPublicItems', 'setCartPublicFromLocStor']),
        ...mapActions('publicBrands', ['getBrands']),
        ...mapActions('retailerProducts', ['getProducts']),
        ...mapActions('retailerLists', ['getLists']),
        ...mapActions('mainbrands', {
            getMainBrands: 'get'
        })
    }
}
</script>
